import { removeUndefinedValues } from '@wix/wix-vod-shared/dist/src/common/utils/object';
import { TRANSCODING_STATUSES } from '@wix/wix-vod-constants/dist/common/transcoding-statuses';
import { VIDEO_SOURCES } from '@wix/wix-vod-constants/dist/common/video-sources';

import { convertISO8601ToSS, convertISO8601ToMMSS } from 'shared/utils/time';
import { FREE_VIDEO_DEAL_INFO } from '@wix/wix-vod-constants/dist/common/video-deal-info';
import getThumbnail from './get-thumbnail';

export default function parseYoutubeVideo(videoData) {
  const { player = {}, snippet = {}, contentDetails = {} } = videoData;

  let { id: externalId } = videoData;

  const { embedHtml } = player;
  const { channelId, title, description, thumbnails, tags, category } = snippet;
  const { duration, videoId } = contentDetails;

  const width = embedHtml && Number(embedHtml.match(/width="(\d+)/)[1]);
  const height = embedHtml && Number(embedHtml.match(/height="(\d+)/)[1]);
  const categories = category ? [category] : [];
  // >_<
  if (_.isObject(externalId)) {
    externalId = externalId.videoId;
  }
  externalId = externalId || videoId;

  const mediaExternUrl = `//www.youtube.com/embed/${externalId}`;
  const coverUrl = getThumbnail(thumbnails);

  let durationSec;
  let durationStr;
  if (duration) {
    durationSec = convertISO8601ToSS(duration);
    durationStr = convertISO8601ToMMSS(duration);
  }

  return removeUndefinedValues({
    externalId,
    coverUrl,
    width,
    height,
    description,
    title,
    tags,
    categories,
    mediaExternUrl,
    mediaStatus: TRANSCODING_STATUSES.READY,
    channelId,
    dealInfo: FREE_VIDEO_DEAL_INFO,
    durationSec,
    durationStr,
    videoSource: VIDEO_SOURCES.YOUTUBE,
  });
}
